import { Controller } from "@hotwired/stimulus";
import videojs from "video.js";

export default class extends Controller {
  connect() {
    this.player = videojs(this.element);
    this.player.fill(true);
  }
}
